import { render } from "./ButtonClose.vue?vue&type=template&id=4014609b"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__